import { AppointmentDetails, AppointmentDetailsQuery } from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { Message, MessageType, StandardSpinner, StyledFlex } from '@dreryk/react-components';

import { calendarTranslationKeys } from '../../../../../translations';

type AppointmentContextDialogTitleLoaderRenderProps = Readonly<{ appointmentDetails: AppointmentDetails }>;

type AppointmentContextDialogTitleLoaderProps = Readonly<{
   appointmentId: number;
   children: (renderProps: AppointmentContextDialogTitleLoaderRenderProps) => JSX.Element;
}>;

export const AppointmentContextDialogTitleLoader = (props: AppointmentContextDialogTitleLoaderProps): JSX.Element => {
   const {
      data: appointmentDetails,
      loading: appointmentDetailsLoading,
      error: appointmentDetailsError,
   } = useCqrsGet<AppointmentDetails>(() => {
      const query = new AppointmentDetailsQuery();
      query.appointmentId = AppointmentId.of(props.appointmentId);
      return query;
   });

   if (appointmentDetailsLoading) {
      return (
         <StyledFlex justifyContent={'center'}>
            <StandardSpinner />
         </StyledFlex>
      );
   }

   if (appointmentDetailsError) {
      return (
         <Message
            testId={'consentTemplateFetchError'}
            type={MessageType.NEGATIVE}
            label={calendarTranslationKeys.appointmentContextDialog.patientFetchError}
            displayIndicator
         />
      );
   }

   return props.children({ appointmentDetails: appointmentDetails });
};
